module.exports = __webpack_public_path__ + "img/txt_00.23fb7bfe.png";